import type { AnalyticsFilterForm } from 'modules/enps/hooks/useAnalyticsMultiFilters'
import type { AnalyticsFilters } from 'modules/surveys/lib/AnalyticsFilters'

const getSelectedFilters = (
  surveyFilter: AnalyticsFilterForm | undefined,
  requestFilter: AnalyticsFilters
) => {
  if (!surveyFilter?.isActive || surveyFilter?.filters.length) {
    // No filter applied or Advanced filters applied
    requestFilter.teams = []
    requestFilter.locations = []
  } else if (surveyFilter?.default.length) {
    // Simple filter applied
    const simpleFilter = surveyFilter.default[0]
    const { field, value } = simpleFilter?.values

    if (field === 'team') {
      requestFilter.teams = [value]
    } else {
      requestFilter.teams = []
    }

    if (field === 'location') {
      requestFilter.locations = [value]
    } else {
      requestFilter.locations = []
    }
  }
}

export default getSelectedFilters
